import { internal, template } from '../../../vendor/elix.js';

function FloatingLabelBaseMixin(Base) {
  
  return class FloatingLabelBase extends Base {

    get floating() {
      return !!(this[internal.state].focused || this.value);
    }

    [internal.render](changed) {
      super[internal.render](changed);
      this.renderFloatingLabelState();
      this.renderPlaceholder();
    }

    renderFloatingLabelState() {
      const labelElement = this.shadowRoot.querySelector('label');
      if (this.floating) {
        labelElement.classList.add('floating');
      } else {
        labelElement.classList.remove('floating');
      }
    }

    // override from PlaceholderMixin
    // don't display placeholder if also displaying label in non floating state
    renderPlaceholder() {
      const inner = this.shadowRoot.querySelector(this.innerSelector || '#inner');
      if (inner) {
        inner.placeholder = this.floating || !this.label ? this.placeholder : '';
      }
    }

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          label {
            background-color: var(--tp-floating-label-mixin-background-color);
            pointer-events: none;
            position: absolute;
            transition: var(--tp-floating-label-mixin-transition);
          }

          label.floating {
            color: var(--tp-floating-label-mixin-font-color);
            font-family: var(--tp-floating-label-mixin-font-family);
            font-size: var(--tp-floating-label-mixin-font-size);
            letter-spacing: 0.77px;
            line-height: normal;
            padding: 0px 4px;
            --webkit-font-smoothing: antialiased;
          }

          .inputStateContainer.disabled label.floating {
            color: var(--tp-floating-label-mixin-font-color-disabled);
          }

          .inputStateContainer:not(.disabled):not(.error).focused label.floating {
            color: var(--tp-floating-label-mixin-font-color-focused);
          }

          .inputStateContainer:not(.disabled):not(.error):not(.focused):hover label.floating {
            color: var(--tp-floating-label-mixin-font-color-hover);
          }

          .inputStateContainer.error label.floating {
            color: var(--tp-floating-label-mixin-font-color-error);
          }

        </style>
        
        `
      );

    }

  }
}

export default FloatingLabelBaseMixin;
